import { CommonModule } from '@angular/common';
import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartData } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { ChartType } from 'src/app/shared/common';
import { BaseChartComponent } from '../base-chart-component/base-chart.component';
import { BaseChart } from 'src/app/core/data/model';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [CommonModule, NgChartsModule],
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent extends BaseChartComponent<BaseChart> implements OnInit, OnChanges {
  override chartType: ChartType = ChartType.BAR;
  chartData: ChartData<ChartType.BAR, number[], string | string[]>;
  // inputs
  @Input() stepSize: number = 2;
  @Input() grace: number = 2;
  @Input() isHorizontal: boolean = false;
  @Input() isStacked: boolean = false;
  constructor(injector: Injector) {
    super(injector);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['data']) {
      this.chartData = changes["data"].currentValue;
      this.buildChartData();
      this.setChartConfigs();
    }
  }

  // hooks
  override ngOnInit(): void {
    super.ngOnInit();
  }

  // protected

  override buildChartData(): void {
    this.chartData = {
      labels: this.labels,
      datasets: this.data?.map((dataItem) => {
        const dataSetItem: any = {};
        dataSetItem['data'] = [...dataItem['dataSet']];
        dataSetItem['backgroundColor'] = dataItem['backgroundColor'];
        dataSetItem['label'] = dataItem['label'];
        dataSetItem['borderColor'] = 'white';
        dataSetItem['borderWidth'] = 2;
        return dataSetItem;
      }),
    };
  }

  override setChartConfigs(): void {
    const axisConfigs: object = {};
    super.setChartConfigs();
    this.chartOptions = {
      ...this.chartOptions,
      indexAxis: this.isHorizontal ? 'y' : 'x',
      ...{
        scales: {
          x: this.setAxisConfigs('x'),
          y: this.setAxisConfigs('y'),
        },
      },
    };
  }

  // privates
  private setAxisConfigs(axis: 'x' | 'y'): object {
    return {
      stacked: this.isStacked,
      beginAtZero: true,
      min: 0,
      grace: this.grace,
      axis: axis,
      reverse: axis === 'x' && this.language === 'ar' ? true : false,
      ticks: {
        unitStepSize: this.stepSize,
      },
    };
  }
}
